
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.md?watch=parent';
    export const demoIndex = {
  ids: ["treemap-demo-common","treemap-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Treemap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Treemap/index.md?type=demo')
};